module.exports = __webpack_public_path__ + "static/img/ldr_5mm-1.1c57767.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/ldr_5mm-1.svg
// module id = J5YW
// module chunks = 0